export default "__VITE_ASSET__CStPG1H6__"